import "../Styles/footer.css";
import GithubIco from '../../Media/github-icon.svg';
const Footer = () => {
    return (
        <footer>
            <div className="footer-left">Made with ❤️ by Hannan Max aka Hannanahmad Shaikh</div>
            <div className="footer-right">
                <a href="https://www.hannanmax.com"  target="_blank" rel="noreferrer">
                    <img src={GithubIco} className="github-icon" alt="www.hannanmax.com"/>
                </a>
            </div>
        </footer>
    );
};

export default Footer;
